module.exports = __webpack_public_path__ + "img/bit_withdraw_icon.a543cc72.svg";